import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseUI } from '../../base.ui';
import { Document, FullClient } from '../../../domain/data';
import { ParentFormDirective } from '../../../directives/parent-form.directive';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    selector: 'thr-full-data-five-natural-person',
    templateUrl: './full-data-five-natural-person.component.html',
    styleUrls: ['./full-data-five-natural-person.component.scss'],
})
export class FullDataFiveNaturalPersonComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy {
    public form: NgForm;
    public isFormValid = false;
    public isDisabled = false;
    public anyGuardianShipDocumentMissing = false;

    @Input()
    client: FullClient;

    @Input()
    isAdmin = false;

    @Input()
    isValidated = false;

    @Output()
    documentView: EventEmitter<Document> = new EventEmitter();

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('isAdmin' in changes || 'isValidated') {
            this.isDisabled = this.isAdmin || this.isValidated;

            if (!this.isAdmin && this.isValidated) {
                this.anyGuardianShipDocumentMissing =
                    this.client.documents && this.client.documents.some((document) => document.isGuardianShip && !document.isValidated());
            }
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = this.formDirective.controlContainer as NgForm;

        if (this.form) {
            this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    onDocumentView(document: Document) {
        this.documentView.emit(document);
    }
}
